export default __webpack_public_path__ + "static/media/guinness_pint_level.c38c0501.png";